export const LANGUAGES = [
  { code: "en", name: "English", tts: "en-US" },
  { code: "es", name: "Spanish", tts: "es-ES" },
  { code: "fr", name: "French", tts: "fr-FR" },
  { code: "de", name: "German", tts: "de-DE" },
  { code: "it", name: "Italian", tts: "it-IT" },
  { code: "pt", name: "Portuguese", tts: "pt-BR" },
  { code: "ru", name: "Russian", tts: "ru-RU" },
  { code: "ja", name: "Japanese", tts: "ja-JP" },
  { code: "ko", name: "Korean", tts: "ko-KR" },
  { code: "zh", name: "Chinese (Simplified)", tts: "zh-CN" },
  { code: "zh-TW", name: "Chinese (Traditional)", tts: "zh-TW" },
  { code: "hi", name: "Hindi", tts: "hi-IN" },
  { code: "bn", name: "Bengali", tts: "bn-IN" },
  { code: "ta", name: "Tamil", tts: "ta-IN" },
  { code: "te", name: "Telugu", tts: "te-IN" },
  { code: "mr", name: "Marathi", tts: "mr-IN" },
  { code: "ur", name: "Urdu", tts: "ur-PK" },
  { code: "ar", name: "Arabic", tts: "ar-SA" },
  { code: "fa", name: "Persian", tts: "fa-IR" },
  { code: "tr", name: "Turkish", tts: "tr-TR" },
  { code: "nl", name: "Dutch", tts: "nl-NL" },
  { code: "sv", name: "Swedish", tts: "sv-SE" },
  { code: "no", name: "Norwegian", tts: "nb-NO" },
  { code: "da", name: "Danish", tts: "da-DK" },
  { code: "fi", name: "Finnish", tts: "fi-FI" },
  { code: "pl", name: "Polish", tts: "pl-PL" },
  { code: "cs", name: "Czech", tts: "cs-CZ" },
  { code: "el", name: "Greek", tts: "el-GR" },
  { code: "he", name: "Hebrew", tts: "he-IL" },
  { code: "hu", name: "Hungarian", tts: "hu-HU" },
  { code: "ro", name: "Romanian", tts: "ro-RO" },
  { code: "uk", name: "Ukrainian", tts: "uk-UA" },
  { code: "vi", name: "Vietnamese", tts: "vi-VN" },
  { code: "th", name: "Thai", tts: "th-TH" },
  { code: "id", name: "Indonesian", tts: "id-ID" },
  { code: "ms", name: "Malay", tts: "ms-MY" },
  { code: "fil", name: "Filipino", tts: "fil-PH" },
  { code: "sw", name: "Swahili", tts: "sw-KE" },
  { code: "yo", name: "Yoruba", tts: "yo-NG" },
  { code: "ha", name: "Hausa", tts: "ha-NG" },
  { code: "am", name: "Amharic", tts: "am-ET" },
  { code: "zu", name: "Zulu", tts: "zu-ZA" },
  { code: "pa", name: "Punjabi", tts: "pa-IN" },
  { code: "gu", name: "Gujarati", tts: "gu-IN" },
  { code: "kn", name: "Kannada", tts: "kn-IN" },
  { code: "ml", name: "Malayalam", tts: "ml-IN" },
  { code: "si", name: "Sinhala", tts: "si-LK" },
  { code: "ne", name: "Nepali", tts: "ne-NP" },
  { code: "sr", name: "Serbian", tts: "sr-RS" },
  { code: "bg", name: "Bulgarian", tts: "bg-BG" },
];

const GOOGLE_CODE_MAP = { zh: "zh-CN", "zh-TW": "zh-TW", fil: "tl", he: "iw" };
export const getGoogleCode = (code) => GOOGLE_CODE_MAP[code] || code;

const LANG_KEY = "moviepulse_lang";

export const getLang = () => localStorage.getItem(LANG_KEY) || "en";

export const setGlobalLang = (code) => {
  localStorage.setItem(LANG_KEY, code);
  window.dispatchEvent(new Event("mp-lang-changed"));
};

export const getTtsLocale = (code) => (LANGUAGES.find((l) => l.code === code) || LANGUAGES[0]).tts;
